interface PlusIconProps {
    color?: string;
    circleColor?: string;
    className?: string;
}

function PlusIcon({ color = '#EEE', circleColor = 'currentColor', className }: PlusIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="16"
            fill="none"
            className={className}
        >
            <circle
                cx="7.5"
                cy="7.5"
                r="7.5"
                fill={circleColor}
                transform="matrix(-1 0 0 1 15 .5)"
            />
            <path stroke={color} strokeLinecap="round" d="M7.5 4.5v7M11 8H4" />
        </svg>
    );
}

export default PlusIcon;
